import Marquee3k from 'marquee3000';


//------------------
// Components 
//------------------
import video from './components/video.js';
import menu from './components/menu.js';
import bind_filters from './components/filters.js';
import landing from './components/landing.js';
import copy_links from './components/copy.js';
// import cheat from './components/cheat.js';

import swiper from './components/swipers.js';

import animate_eye from './components/ani.js';

import expanding_block from './components/expanding-block.js';


var mouse = {
    x: false,
    y: false
};

window.loadCredits = false;


function page_load(){
    
    bild_ajax_load();
    animate_eye();
    video();
    bind_filters();
    landing();
    copy_links();
    markActiveLinks();
    expanding_block();
    swiper();

    if(document.querySelector('.credits-wrap')){
        window.requestAnimationFrame(scrollStep);
    }
};

window.onload = function(event) {
    Marquee3k.init();
    menu();
    page_load();
    // cheat();

};


var stepCount = 0;
var eyes = document.querySelectorAll('.eye');

for (let a = 0; a < eyes.length; a++) {
    const elm = eyes[a];
    elm.addEventListener('click', function(e){
       
        elm.classList.remove('animate');
        setTimeout(function(){
            elm.classList.add('animate');
        },10);
    });
    
}

var blinkCount = 0;

function step() {

    var top = 0;
    let wh =  window.innerHeight;
   
    let deets = document.querySelector('.deets');
    
    if(deets){

        let h = deets.offsetHeight;
        let offset = wh - h;

        if(offset < 0){
            top = offset - 20;
        }

    }

    document.querySelector(':root').style.setProperty('--sticky', top+'px');
    document.querySelector(':root').style.setProperty('--win-height', wh+'px');

    if(window.loadCredits){
        load_page('/credits');
        window.loadCredits = false;
    }

    window.requestAnimationFrame(step);

}


function scrollStep() {

    window.scrollBy(0, 2);

    var scrollTop = document.documentElement.scrollTop;
    var windowHeight = window.innerHeight;
    var fullHeight = document.documentElement.scrollHeight;

    if (scrollTop + windowHeight >= fullHeight) {
        window.scrollTo(0,0);
    }

    if(document.querySelector('.credits-wrap')){
        window.requestAnimationFrame(scrollStep);
    }

}



document.addEventListener('mousemove', function(e){

    mouse.x = e.clientX;
    mouse.y = e.clientY;

})
    
window.requestAnimationFrame(step);



function calculateDistance(mouseX, mouseY, element) {
    const elementRect = element.getBoundingClientRect();
    const elementWidth = elementRect.width;
    const elementHeight = elementRect.height;
    const elementX = elementRect.left + elementWidth / 2;
    const elementY = elementRect.top + elementHeight / 2;

    const distanceX = Math.abs(elementX - mouseX) - elementWidth / 2;
    const distanceY = Math.abs(elementY - mouseY) - elementHeight / 2;

    const distance = Math.sqrt(Math.pow(Math.max(distanceX, 0), 2) + Math.pow(Math.max(distanceY, 0), 2));
    return distance;

  }


  function markActiveLinks() {
    const currentPageUrl = window.location.href;
    const allLinks = document.querySelectorAll('a');
  
    allLinks.forEach(link => {
      if (link.href === currentPageUrl) {
        link.classList.add('active');
      }else{
        link.classList.remove('active');
      }
    });
}


window.addEventListener('popstate', function(event) {
    location.reload(true);
});


function bild_ajax_load(){

    var links = document.querySelectorAll('a');
    for (let a = 0; a < links.length; a++) {
       let elm = links[a];

        if(isInternalLink(elm) && !elm.classList.contains('bound')){
            elm.classList.add('bound');
            elm.addEventListener('click', load_content);
        }
        
    }

}


function load_page(path){

    var cur = document.querySelector('main');
    var parent = cur.parentNode;

    for (let a = 0; a <  window.animations.length; a++) {
        const animation = window.animations[a];
        animation.setSpeed(Math.floor(Math.random() * 5) + 2);
        animation.playSegments([0, 13], true);
      
    }

    cur.style.opacity = 0;

    var landing = document.querySelector('.landing-wrap');
    if(!landing){
        document.body.classList.remove('menu-open');
    }

    cur.style.filter = "blur(10px)";
    cur.style.opacity = 0;
    
    window.history.pushState({}, '', path);

    fetch(path)
    .then(function(response) {
      return response.text();
    })
    .then(function(data) {

        document.body.classList.remove('menu-open');
        
        for (let a = 0; a <  window.animations.length; a++) {
            const animation = window.animations[a];

            animation.setSpeed(Math.floor(Math.random() * 5) + 2);
            animation.playSegments([13, 25], true);

        }
        
        window.scrollTo(0, 0);

       
        
        let html =  extractInnerContent(data);
        let content = html.querySelector('main');

        let newStyles = html.querySelector('.color-prefs');
        let head = document.querySelector('head');
        let oldStyles = head.querySelector('.color-prefs');

        if(newStyles && oldStyles){
            oldStyles.parentNode.removeChild(oldStyles);
            head.append(newStyles);
        }

    
        content.style.opacity = 0;
        cur.parentNode.removeChild(cur);
        parent.append(content);

        setTimeout(function(){
            content.style.opacity = 1;
        }, 50);

        page_load();
        
    })
    .catch(function(error) {
      console.error('Error:', error);
    });
    
};
  


function load_content(e){

    e.preventDefault();
    
    let elm = this;

    if(elm.classList.contains('dragging')){
        elm.classList.remove('dragging')
        return;
    }

   
    let newUrl = elm.href;
    let path = getUrlPathFromHref(newUrl);
  
    load_page(path);
    
}


function isInternalLink(link) {
   
    var currentHostname = window.location.hostname;
    var linkHostname = getHostnameFromHref(link.href);

    // Compare the hostnames
    if(link.href.includes('action')){
        return false;
    }else{
        return currentHostname === linkHostname;
    }
}
  
function getHostnameFromHref(href) {

    if(href){
        var url = new URL(href);
        return url.hostname;
    }else{
        return false;
    }
}
  


  function getUrlPathFromHref(href) {
    var link = document.createElement('a');
    link.href = href;

    return link.pathname;
 
  }


function extractInnerContent(htmlString) {
    var tempElement = document.createElement('div');
    tempElement.innerHTML = htmlString;
    return tempElement;
}



function nletterPop() {
    // ml_account('webforms', '4211725', 'e6d6p9', 'show')
}

function runFunctionOnce() {
    var hasRun = getCookie('nletter');
    if (!hasRun) {
        setTimeout(function() {
            nletterPop();
            setCookie('nletter', 'true', 1); // Set a cookie to prevent running the function again during this session (expires in 1 day)
        }, 5000); // 5000 milliseconds = 5 seconds
    }
}

function setCookie(name, value, days) {
    var expires = '';
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + value + expires + '; path=/';
}

function getCookie(name) {
    var nameEQ = name + '=';
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1, cookie.length);
        }
        if (cookie.indexOf(nameEQ) === 0) {
            return cookie.substring(nameEQ.length, cookie.length);
        }
    }
    return null;
}


function loop_scroll(){


    if(document.querySelector()){
        
    }

};

// Call runFunctionOnce to trigger the function execution after 5 seconds if it hasn't run before in this session
runFunctionOnce();